module.exports = __webpack_public_path__ + "static/media/intro.87ffca6f.mp3";